import React from 'react'
import { PropTypes } from 'prop-types'

let timeout

const searchChanged = (onChange, location, value) => {
  if (timeout) clearTimeout(timeout)
  timeout = setTimeout(() => {
    onChange({ query: value,
      lat: location.success ? location.coords.latitude : null,
      lon: location.success ? location.coords.longitude : null })
  }, 500)
}

const SiteSearch = ({ searchSites, location }) => (
  <div className="ln-c-form-group">
    <div>
      <input
        id="site-search"
        type="search"
        className="ln-c-text-input"
        placeholder="Search..."
        onChange={({ target }) => searchChanged(searchSites, location, target.value)}
      />
    </div>
  </div>
)

SiteSearch.propTypes = {
  searchSites: PropTypes.func.isRequired,
  location: PropTypes.shape({
    coords: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string
    })
  })
}

SiteSearch.defaultProps = {
  location: { success: false }
}

export default SiteSearch



// WEBPACK FOOTER //
// ./src/components/SiteSearch/SiteSearch.jsx